export default [
    {
        title: 'تنظیمات سیستم',
        icon: 'SettingsIcon',
        children: [
            // {
            //     title: 'سامانه voip',
            //     icon: 'PhoneCallIcon',
            //     permission: 'Settings_Voip',
            //     route: 'Settings_Voip'
            // },
            {
                title: 'سامانه پیامک',
                icon: 'MailIcon',
                permission: 'settings.sms',
                route: 'Settings_Sms'
            },
            // {
            //     title: 'فاکتور ها',
            //     icon: 'ClipboardIcon',
            //     permission: 'Settings_Factor',
            //     route: 'Settings_Factor'
            // },
            // {
            //     title: 'سیستم فروش',
            //     icon: 'ClipboardIcon',
            //     permission: 'Settings_Sale',
            //     route: 'Settings_Sale'
            // },
        ]
    }
]